/**
 * T-179: broken grey thumbnails in "You might also like".
 *
 * Two causes, both here:
 *
 * 1. The related-posts list rendered `post.thumbnailUrl` raw. The feed grid
 *    already had a validator for exactly this — it strips the emoji sprites,
 *    tracking pixels, spacers and avatar CDNs our pollers pick up from RSS —
 *    but it was a private local in PostCardGrid, so the sidebar never got it.
 *    A useful rule trapped in one component is a bug waiting in every other.
 *
 * 2. Even a valid-LOOKING url can 404 or hotlink-block at request time, and
 *    an <img> that fails renders as a broken grey box. There was no onError
 *    anywhere, so nothing could recover. Callers now fall back on error.
 */
export function isValidThumbnail(url: string | null | undefined): boolean {
  if (!url) return false;

  const lowerUrl = url.toLowerCase();

  // Known placeholder patterns to exclude
  const placeholderPatterns = [
    'placeholder',
    'default',
    'no-image',
    'noimage',
    'blank',
    'emoji',
    'smiley',
    'gravatar',
    'avatar',
    's.w.org',      // WordPress emoji CDN
    '72x72',        // Small emoji size
    '1x1',
    'pixel',
    'spacer',
    'transparent',
    'data:image/svg',
    '/ads/',
    '/tracking/',
  ];

  for (const pattern of placeholderPatterns) {
    if (lowerUrl.includes(pattern)) {
      return false;
    }
  }

  return true;
}
